exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.referral_purchase-tabs[data-v-5075082e]{\n  padding: 12px;\n}\n", ""]);

// exports
